var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutLogin',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('LayoutLoginCard',{staticClass:"oAuthCallbackView-card"},[_c('div',{staticClass:"d-flex justify-center my-6"},[_c('Logo',{attrs:{"type":"big"}})],1),(_vm.isLoading)?_c('LoaderSpinner'):_vm._e()],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }